import { Flex } from "waapi/waap-ui/components/Flex/Flex.js";
import { ITheme } from "waapi/waap-ui/components/Theme/Theme.types.js";
import styled from "styled-components";

export const getSelectStyles = ({ theme }: { theme: ITheme }) => ({
    indicatorsContainer: (provided) => ({
        ...provided,
        padding: "0px",
    }),
    control: (provided) => ({
        ...provided,
        border: `2px solid ${theme.grayscale[50]}`,
        borderRadius: theme.radius.s,
        cursor: "pointer",
        padding: "0 0.5rem",
    }),
});

const getHeight = (size: "small" | "large" | "medium") => {
    if (size === "small") return "1.7em";
    return "1.5em";
};

export const StyledLangOptionLabel = styled(Flex)<{
    size: "small" | "large" | "medium";
}>`
    & > svg {
        height: ${(props) => getHeight(props.size)};
        width: ${(props) => getHeight(props.size)};
    }
`;
